import React from 'react';
import California_classes from './california_classes';
import TopNavbar from '../../components/TopNavbar';
import { Outlet } from 'react-router-dom';
import Learning_us_states from '../learning_us_states';

const California = () => {
  return (
    <div>
    <TopNavbar />
    <Learning_us_states />
      <California_classes />

      <Outlet />
    </div>
  );
}

export default California;
